import { HorizonsTeam } from "./horizons-team.model";
import { Team } from "./team.model";

export class Entity {
  [key: string | number]: any;
  id!: number;
  entityTypeId!: number;
  entityType?: EntityType;
  parentEntityId!: number;
  parentEntity?: Entity;
  childEntities?: Entity[];
  internalCode!: number;
  identityCode!: number;
  email!: string;
  phone!: string;
  contact!: string;
  name!: string;
  address!: string;
  country!: string;
  cityZipCode!: number;
  teamId!: number;
  team?: Team;
  horizonsTeamId!: number;
  horizonsTeam?: HorizonsTeam;
  isBase?: boolean;
  timezone!: string;
  createdAt!: string;
  updatedAt!: string;
  deletedAt!: string;
  calculatedTeamName?: string | null;
}

export class EntityType {
  id!: number;
  name!: string;
  createdAt!: string;
  updatedAt!: string;
  deletedAt!: null;
}
